webpackJsonp([212839066777427],{

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = BlogIndex;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _glamorous = __webpack_require__(30);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _glamor = __webpack_require__(10);
	
	var _typography = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var throbbing = _glamor.css.keyframes('pulsate', {
	  '0%': { transform: "rotate(0deg) scale(1)" },
	  '50%': { transform: "rotate(180deg) scale (0.8)" },
	  '80%': { transform: "rotate(360deg) scale(0.001)" },
	  '100%': { transform: "rotate(360deg) scale(0)" }
	});
	
	var blogPostsContainer = (0, _glamor.css)({
	  display: "grid",
	  gridTemplateColumns: "repeat(12, 8%)",
	  gridTemplateRows: "auto",
	  width: "100%",
	  justifyContent: "space-evenly"
	});
	
	var blogPostPreview = (0, _glamor.css)({
	  gridColumn: "span 3",
	  padding: "0 10px",
	  "@media (max-width: 768px)": {
	    gridColumn: "span 13"
	  },
	  "&:hover": {
	    animation: throbbing + " 3s linear 2.5s 1"
	  }
	});
	
	var blogPostTitle = (0, _glamor.css)({
	  margin: "1rem 0 0 0"
	});
	
	var blogLinkStyle = (0, _glamor.css)({
	  color: "black",
	  "&:hover": {
	    textDecoration: "none"
	  }
	});
	
	var blogPostDate = (0, _glamor.css)({
	  margin: "0.5rem 0",
	  fontSize: (0, _typography.rhythm)(0.4)
	});
	
	var blogPostCopy = (0, _glamor.css)({
	  fontSize: (0, _typography.rhythm)(0.45),
	  textAlign: "justify"
	});
	
	function BlogIndex(_ref) {
	  var data = _ref.data;
	  var posts = data.allMarkdownRemark.edges;
	
	  return Glamor.createElement(
	    "div",
	    null,
	    Glamor.createElement(
	      "h1",
	      null,
	      "Blog"
	    ),
	    Glamor.createElement(
	      _reactHelmet2.default,
	      null,
	      Glamor.createElement(
	        "title",
	        null,
	        "`Blog posts: Russell Schmidt`"
	      )
	    ),
	    Glamor.createElement(
	      "div",
	      { className: blogPostsContainer },
	      posts.filter(function (post) {
	        return post.node.frontmatter.title.length > 0;
	      }).map(function (_ref2) {
	        var post = _ref2.node;
	
	        return Glamor.createElement(
	          "div",
	          { className: blogPostPreview, key: post.id },
	          Glamor.createElement(
	            _gatsbyLink2.default,
	            { className: blogLinkStyle, to: post.frontmatter.path },
	            Glamor.createElement(
	              "h3",
	              { className: blogPostTitle },
	              post.frontmatter.title
	            ),
	            Glamor.createElement(
	              "h4",
	              { className: blogPostDate },
	              post.frontmatter.date
	            ),
	            Glamor.createElement(
	              "p",
	              { className: blogPostCopy },
	              post.excerpt
	            )
	          )
	        );
	      })
	    )
	  );
	}
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-e1262bfe9287853906b1.js